import { connect } from 'react-redux'

import { getClientList } from '../../../modules/clients'

import Component from './Clients'

const mapActionCreators = {
  getClientList,
}

const mapStateToProps = (state) => ({
  clientList: state.clients.get('clientList'),
  clientCount: state.clients.get('clientCount'),
  isFetching: state.clients.get('isFetching'),
})

export default connect(mapStateToProps, mapActionCreators)(Component)



// WEBPACK FOOTER //
// ./src/containers/clients/list/index.js